import { Button } from "@/components/ui/button"
import { ArrowRight } from "@phosphor-icons/react"

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-navy text-ivory pt-20">
      {/* Hero image */}
      <div className="absolute inset-0 overflow-hidden">
        <img 
          src="/images/hero-bg.jpg" 
          alt="" 
          className="w-full h-full object-cover object-top"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-navy/60" />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/20 text-gold text-sm font-medium uppercase tracking-wider mb-6">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse"></span>
            Elite Football Development
          </div>
          
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tight leading-tight mb-6">
            Where <span className="text-gold">Football</span> Dreams Become Reality. Asia & Africa to the World.
          </h1>
          
          <p className="text-xl sm:text-2xl text-ivory/80 leading-relaxed mb-12 max-w-3xl">
            ZOE Football Academy develops elite footballers through discipline, character, and world-class training—creating clear pathways to international clubs, scholarships, and professional football careers.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              className="bg-gold text-navy hover:bg-gold/90 font-medium uppercase tracking-wide text-base px-8 py-6"
              onClick={() => {
                const section = document.getElementById('apply')
                section?.scrollIntoView({ behavior: 'smooth' })
              }}
            >
              Apply for Trials
              <ArrowRight className="ml-2" weight="bold" />
            </Button>
            
            <Button 
              size="lg"
              variant="outline"
              className="border-2 border-ivory bg-transparent text-ivory hover:bg-ivory hover:text-navy font-medium uppercase tracking-wide text-base px-8 py-6"
              onClick={() => {
                const section = document.getElementById('contact')
                section?.scrollIntoView({ behavior: 'smooth' })
              }}
            >
              Partner With Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
